import 'styled-components'

import { StylesConfig } from './index'

declare module 'styled-components' {
  export interface DefaultTheme extends StylesConfig {}
}
